// Podtemat 1 - podstawianie do wzorów.

import * as BasicSubstitution from "./podtemat1_podstawianie_do_wzorow_types/FormulaSubstitutionBasicTask";
import * as GeometrySubstitution from "./podtemat1_podstawianie_do_wzorow_types/FormulaSubstitutionGeometryTask";
import * as FractionSubstitution from "./podtemat1_podstawianie_do_wzorow_types/FormulaSubstitutionFractionTask";

export const registry = {
  FormulaSubstitutionBasicTask: BasicSubstitution,
  FormulaSubstitutionGeometryTask: GeometrySubstitution,
  FormulaSubstitutionFractionTask: FractionSubstitution,
};

export function generateTasks(options = {}) {
  return [
    BasicSubstitution.generateTask(options),
    GeometrySubstitution.generateTask(options),
    FractionSubstitution.generateTask(options),
  ];
}

function moduleFor(task) {
  const mod = registry[task?.type];
  if (!mod) throw new Error(`Unknown task type in 2_6_1: ${task?.type}`);
  return mod;
}

export function renderTask(task) {
  return moduleFor(task).renderTask(task);
}

export function renderInput(task, userAnswer, onChange, disabled) {
  return moduleFor(task).renderInput(task, userAnswer, onChange, disabled);
}

export function checkAnswer(task, userAnswer) {
  return moduleFor(task).checkAnswer(task, userAnswer);
}

export function renderAnswer(task) {
  return moduleFor(task).renderAnswer(task);
}

export function renderExplanation(task) {
  return moduleFor(task).renderExplanation(task);
}

export function renderUserAnswer(userAnswer, task) {
  return moduleFor(task).renderUserAnswer(userAnswer, task);
}